import { jsx as _jsx } from "react/jsx-runtime";
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { BaseButtonsView } from './BaseButtonsView';
import { HubInterestToBusinessGoal } from '../experiments/acq134/BusinessGoalsOption';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UISideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import I18n from 'I18n';
import styled, { css } from 'styled-components';
import { getHubOptionTitle } from '../experiments/acq134/getHubOptionTitle';
import { sidebarAnimationCss } from '../animation/Animations.styles';
import { useTracker } from '../tracking/useTracker';
import { getFlowKey } from '../routing/getFlowKey';
import { Flow } from 'signup-constants/Flow';
import { HubInterestToJobField } from '../signup-data/hubInterestMappings';
import { getIsMobile } from '../utils/deviceUtils';
const StyledSideNav = styled(UISideNav).withConfig({
  displayName: "BusinessGoalsView__StyledSideNav",
  componentId: "ml05f0-0"
})(["float:left;padding-top:20px;margin-right:43px;", ""], props => props.flowKey === Flow.Crm && css(["", ""], sidebarAnimationCss));
const StyledNavItem = styled(UISideNavItem).withConfig({
  displayName: "BusinessGoalsView__StyledNavItem",
  componentId: "ml05f0-1"
})(["height:36px;margin-bottom:20px;"]);
const hubInterestOptions = [HubInterestOption.Marketing, HubInterestOption.Sales, HubInterestOption.CustomerService, HubInterestOption.CMS];

const BusinessGoalsView = () => {
  const {
    data: hubInterest,
    setData: setHubInterestData
  } = useSignupData(Data.HubInterest);
  const {
    setData: setJobFieldData
  } = useSignupData(Data.JobField);
  const {
    data: managementLevel
  } = useSignupData(Data.ManagementLevel);
  const options = HubInterestToBusinessGoal[hubInterest];
  const Tracker = useTracker();
  const flowKey = getFlowKey();

  const getSideComponent = () => {
    return !getIsMobile() ? /*#__PURE__*/_jsx(StyledSideNav, {
      flowKey: flowKey,
      children: hubInterestOptions.map((option, index) => {
        return /*#__PURE__*/_jsx(StyledNavItem, {
          active: hubInterest === option,
          title: I18n.text(`views.HUB_OPTION.options.${option}`),
          onOpenChange: () => {
            setHubInterestData(option);
            setJobFieldData(HubInterestToJobField[option]);
            Tracker.signupInteraction(`switch-hub-option-sidebar`, {
              hubInterest: option
            });
          }
        }, index);
      })
    }) : null;
  };

  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: 1,
    optionHeight: "70px",
    options: options,
    shouldDisableAutofocus: true,
    sideComponent: getSideComponent(),
    title: getHubOptionTitle(managementLevel)
  });
};

export default BusinessGoalsView;